import { useQuery, useMutation, useQueryClient } from 'react-query'
import { agendamentoRetornoService } from '../services/agendamentoRetornoService'
import { useToast } from '@chakra-ui/react'

import { useReducer } from 'react'

const reducer = (state, action) => {
  switch (action.type) {
    case 'EMAIL':
    case 'WHATSAPP':
    case 'TELEFONE':
      return action.type
    default:
      return state
  }
}

export function useAgendamentoRetorno({
  numeroNota = '',
  codigoParceiro = '',
  codigoContato = '',
  numeroPedido = '',
  id_categoria = '',
  id_categoria_email = '',
} = {}) {
  const [state, dispatch] = useReducer(reducer, 'EMAIL')

  const toast = useToast()

  const setAgendamento = (tipo) => {
    dispatch({ type: tipo })
  }

  const queryClient = useQueryClient()

  const getAgendamentos = useQuery({
    queryKey: ['agendamento-retorno', { numeroNota, codigoParceiro, codigoContato, numeroPedido }],
    queryFn: () =>
      agendamentoRetornoService.getAgendamentos({
        numeroNota,
        codigoParceiro,
        codigoContato,
        numeroPedido,
      }),
    refetchOnWindowFocus: false,
    enabled: !!numeroNota && !!codigoParceiro && !!codigoContato && !!numeroPedido,
  })

  const mensagensSistema = useQuery({
    queryKey: ['mensagens-sistema', { id_categoria: id_categoria }],
    queryFn: () => agendamentoRetornoService.getMensagensSistema({ id_categoria }),
    refetchOnWindowFocus: false,
  })

  const agendarRetorno = useMutation({
    mutationFn: (agendamento) => agendamentoRetornoService.agendarRetorno(agendamento),
    onSuccess: () => {
      queryClient.invalidateQueries('agendamento-retorno')

      toast({
        title: 'Agendamento realizado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },

    onError: (error) => {
      toast({
        title: 'Erro ao realizar agendamento',
        description: error.response.data.erros || 'Erro inesperado',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  const deletarAgendamento = useMutation({
    mutationFn: (id) => agendamentoRetornoService.excluirAgendamento(id),
    onSuccess: () => {
      queryClient.invalidateQueries('agendamento-retorno')

      toast({
        title: 'Agendamento excluído com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },

    onError: (error) => {
      toast({
        title: 'Erro ao excluir agendamento',
        description: error.response.data.erros || 'Erro inesperado',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  const emailCategories = useQuery({
    queryKey: 'email-categories',
    queryFn: agendamentoRetornoService.getEmailCategories,
    refetchOnWindowFocus: false,
  })

  const categoriesSistema = useQuery({
    queryKey: 'categories-sistema',
    queryFn: agendamentoRetornoService.getCategoriesSistema,
    refetchOnWindowFocus: false,
  })

  const emailSubjects = useQuery({
    queryKey: ['email-subjects', { id_categoria_email: id_categoria_email }],
    queryFn: () => agendamentoRetornoService.getEmailSubjects({ id_categoria_email: id_categoria_email }),
    refetchOnWindowFocus: false,
    enabled: !!id_categoria_email,
  })

  const mensagensEmail = useQuery({
    queryKey: ['mensagens-email', { id_categoria, numeroPedido }],
    queryFn: () =>
      agendamentoRetornoService.getEmailMensagens({
        id_categoria,
        numero_pedido: numeroPedido,
      }),
    refetchOnWindowFocus: false,
    enabled: !!id_categoria && !!numeroPedido,
  })

  return {
    getAgendamentos,
    agendarRetorno,
    agendamentoTipo: state,
    setAgendamento,
    mensagensSistema,
    deletarAgendamento,
    categoriesSistema,
    emailCategories,
    emailSubjects,
    mensagensEmail,
  }
}
